import { Articulation } from 'types/articulation';
import ArticulationCreditItem from 'components/credits/credit-items/ArticulationCreditItem';
import FlexContainer from 'components/common/FlexContainer';
import { groupedByRequiredCredentials } from 'utils/articulation';
import useIsMobile from 'hooks/use-is-mobile';
import { useMemo } from 'react';

export type Props = {
  articulations: Articulation[];
};

export default function ArticulationCreditList(props: Props): JSX.Element {
  const { articulations } = props;
  const isMobile = useIsMobile();

  const { list, mobileList } = useMemo<{ list: [string, Articulation[]][]; mobileList: Articulation[] }>(() => {
    const grouped = groupedByRequiredCredentials(articulations);
    if (isMobile) {
      return {
        list: [],
        mobileList: Array.from(grouped.values()).flatMap((articulation) => articulation),
      };
    }
    return {
      list: Array.from(grouped.entries()),
      mobileList: [],
    };
  }, [articulations, isMobile]);

  if (isMobile) {
    return (
      <FlexContainer className='articulation-credit-item-list'>
        {mobileList.map((articulation) => (
          <ArticulationCreditItem key={articulation.ID} articulations={[articulation]} />
        ))}
      </FlexContainer>
    );
  }

  return (
    <FlexContainer className='articulation-credit-item-list'>
      {list.map(([key, articulations]) => (
        <ArticulationCreditItem key={key} articulations={articulations} />
      ))}
    </FlexContainer>
  );
}
